import defaultState from "./state";

const grillaSolicitudesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "GRILLA_SOLICITUDES/OPEN_MODAL_VER_DETALLE": {
      return Object.assign({}, state, {
        modalVerDetalle: action.modalVerDetalle,
        idSolicitudDetalle: action.idSolicitud,
      });
    }

    case "GRILLA_SOLICITUDES/LOADINGFILE": {
      return Object.assign({}, state, {
        loadingFile: action.loadingFile
      })
    }

    default:
      return state;
  }
};

export default grillaSolicitudesReducer;



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/GrillaSolicitudes/reducer.js